import type { Manga, Category, Review } from './types';

export const categories: Category[] = [
  { name: '全部', slug: 'all', icon: 'ri-apps-line' },
  { name: '热血', slug: 'rexue', icon: 'ri-fire-line' },
  { name: '恋爱', slug: 'lianai', icon: 'ri-heart-line' },
  { name: '玄幻', slug: 'xuanhuan', icon: 'ri-magic-line' },
  { name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line' },
  { name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line' },
  { name: '科幻', slug: 'kehuan', icon: 'ri-rocket-line' },
  { name: '校园', slug: 'xiaoyuan', icon: 'ri-building-line' },
  { name: '武侠', slug: 'wuxia', icon: 'ri-sword-line' },
  { name: '冒险', slug: 'maoxian', icon: 'ri-compass-line' },
];

export const mangaList: Manga[] = [
  {
    id: 1,
    title: '斗罗大陆',
    author: '唐家三少',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20style%2C%20martial%20arts%20fantasy%20theme%2C%20young%20warrior%20with%20blue%20spirit%20energy%2C%20dynamic%20action%20pose%2C%20warm%20golden%20and%20blue%20tones%2C%20clean%20illustration%20style%2C%20manga%20cover%20layout%20with%20dramatic%20lighting%2C%20professional%20comic%20art%2C%20vibrant%20colors%20on%20dark%20background&width=400&height=560&seq=manga-douluo&orientation=portrait',
    category: '玄幻',
    rating: 9.5,
    status: '连载中',
    description: '唐门外门弟子唐三，因偷学内门绝学为唐门所不容，跳崖明志时却来到了另一个世界——斗罗大陆。在这里，没有魔法，没有斗气，没有武术，却有神奇的武魂。当唐门暗器遇上异界武魂，一段传奇就此展开...',
    views: 12580000,
    favorites: 890000,
    updatedAt: '2026-08-05',
    chapters: [
      { id: 1, title: '第1话 穿越斗罗大陆', number: 1 },
      { id: 2, title: '第2话 觉醒武魂', number: 2 },
      { id: 3, title: '第3话 入学诺丁', number: 3 },
      { id: 4, title: '第4话 第一魂环', number: 4 },
      { id: 5, title: '第5话 史莱克学院', number: 5 },
      { id: 356, title: '第356话 最终决战', number: 356 },
    ],
    tags: ['玄幻', '热血', '战斗', '异世界'],
  },
  {
    id: 2,
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20style%2C%20modern%20supernatural%20theme%2C%20young%20man%20with%20mysterious%20power%2C%20urban%20fantasy%20setting%2C%20green%20and%20dark%20tones%2C%20mysterious%20atmosphere%2C%20clean%20illustration%20style%2C%20manga%20cover%20layout%2C%20professional%20comic%20art%2C%20dynamic%20composition&width=400&height=560&seq=manga-yiren&orientation=portrait',
    category: '悬疑',
    rating: 9.6,
    status: '连载中',
    description: '随着爷爷尸体被盗，神秘少女冯宝宝的造访，少年张楚岚的平静校园生活被彻底颠覆。急于解开爷爷和自身秘密的张楚岚，与没有任何记忆的"不死少女"冯宝宝开启了"异人"之旅...',
    views: 9800000,
    favorites: 750000,
    updatedAt: '2026-08-04',
    chapters: [
      { id: 1, title: '第1话 神秘少女', number: 1 },
      { id: 2, title: '第2话 异人世界', number: 2 },
      { id: 3, title: '第3话 金光咒', number: 3 },
      { id: 4, title: '第4话 天师府', number: 4 },
      { id: 5, title: '第5话 雷法对决', number: 5 },
    ],
    tags: ['悬疑', '热血', '都市', '异能'],
  },
  {
    id: 3,
    title: '狐妖小红娘',
    author: '小新',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20style%2C%20romantic%20fantasy%20theme%2C%20beautiful%20fox%20spirit%20girl%20with%20flowing%20hair%2C%20pink%20and%20golden%20cherry%20blossom%20background%2C%20soft%20romantic%20lighting%2C%20clean%20illustration%20style%2C%20manga%20cover%20layout%2C%20elegant%20composition%2C%20dreamy%20atmosphere&width=400&height=560&seq=manga-huyao&orientation=portrait',
    category: '恋爱',
    rating: 9.4,
    status: '连载中',
    description: '根据古典小说记载，世上有人有妖，妖会与人相恋。妖寿命千万年，人的寿命有限。人死了，妖活着。人投胎后不记得上辈子的爱。妖如果痴情的话，就去找狐妖"购买"一项服务，让投胎转世的人回忆起前世的爱...',
    views: 8900000,
    favorites: 680000,
    updatedAt: '2026-08-03',
    chapters: [
      { id: 1, title: '第1话 狐妖的约定', number: 1 },
      { id: 2, title: '第2话 转世续缘', number: 2 },
      { id: 3, title: '第3话 涂山苏苏', number: 3 },
      { id: 4, title: '第4话 白月初', number: 4 },
      { id: 5, title: '第5话 前世今生', number: 5 },
    ],
    tags: ['恋爱', '玄幻', '治愈', '转世'],
  },
  {
    id: 4,
    title: '镇魂街',
    author: '许辰',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20style%2C%20dark%20fantasy%20theme%2C%20armored%20warrior%20with%20ancient%20Chinese%20aesthetics%2C%20mysterious%20street%20setting%2C%20dark%20red%20and%20black%20tones%2C%20dramatic%20lighting%2C%20clean%20illustration%20style%2C%20manga%20cover%20layout%2C%20powerful%20composition&width=400&height=560&seq=manga-zhenhun&orientation=portrait',
    category: '热血',
    rating: 9.3,
    status: '连载中',
    description: '普通的应届大学毕业生夏铃在求职之际，收到了一条奇怪的面试通知，误入罗刹街并遭到了危险，幸而被镇魂将曹焱兵搭救。然而接触中，曹焱兵却发现，夏铃并非看起来那样普通...',
    views: 7600000,
    favorites: 580000,
    updatedAt: '2026-08-02',
    chapters: [
      { id: 1, title: '第1话 罗刹街', number: 1 },
      { id: 2, title: '第2话 镇魂将', number: 2 },
      { id: 3, title: '第3话 守护灵', number: 3 },
      { id: 4, title: '第4话 夏铃觉醒', number: 4 },
      { id: 5, title: '第5话 于禁', number: 5 },
    ],
    tags: ['热血', '玄幻', '战斗', '守护灵'],
  },
  {
    id: 5,
    title: '快把我哥带走',
    author: '幽·灵',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20style%2C%20slice%20of%20life%20comedy%20theme%2C%20two%20teenage%20siblings%20arguing%20playfully%2C%20bright%20and%20cheerful%20school%20setting%2C%20warm%20yellow%20and%20sky%20blue%20tones%2C%20clean%20illustration%20style%2C%20manga%20cover%20layout%2C%20fun%20and%20energetic%20composition&width=400&height=560&seq=manga-kuai&orientation=portrait',
    category: '搞笑',
    rating: 9.2,
    status: '已完结',
    description: '"我哥是全世界最讨厌的人！"每天坑妹一万次的哥哥和暴走的妹妹相爱相杀，还有众多好基友加戏不断，日常小片段轻松搞笑，让人笑出腹肌的兄妹日常喜剧！',
    views: 6500000,
    favorites: 480000,
    updatedAt: '2026-07-28',
    chapters: [
      { id: 1, title: '第1话 我的哥哥', number: 1 },
      { id: 2, title: '第2话 零花钱战争', number: 2 },
      { id: 3, title: '第3话 考试风云', number: 3 },
      { id: 4, title: '第4话 秘密日记', number: 4 },
      { id: 5, title: '第5话 哥哥的朋友', number: 5 },
    ],
    tags: ['搞笑', '校园', '日常', '兄妹'],
  },
  {
    id: 6,
    title: '星海镖师',
    author: '颜开',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20style%2C%20sci-fi%20space%20adventure%20theme%2C%20young%20bounty%20hunter%20with%20advanced%20tech%20weapon%2C%20star-filled%20cosmic%20background%2C%20purple%20and%20silver%20tones%2C%20clean%20illustration%20style%2C%20manga%20cover%20layout%2C%20futuristic%20composition&width=400&height=560&seq=manga-xinghai&orientation=portrait',
    category: '科幻',
    rating: 9.1,
    status: '连载中',
    description: '在遥远的未来，人类已经踏入星际时代。星海镖师——这个星际时代最危险的职业，他们穿梭于各个星球之间，护送各种神秘的货物。少年唐小镖怀揣着成为最强镖师的梦想，踏上了浩瀚星海的冒险之旅。',
    views: 5400000,
    favorites: 390000,
    updatedAt: '2026-08-01',
    chapters: [
      { id: 1, title: '第1话 镖师之路', number: 1 },
      { id: 2, title: '第2话 第一个任务', number: 2 },
      { id: 3, title: '第3话 星际盗贼', number: 3 },
      { id: 4, title: '第4话 神秘货物', number: 4 },
      { id: 5, title: '第5话 同伴', number: 5 },
    ],
    tags: ['科幻', '冒险', '热血', '星际'],
  },
  {
    id: 7,
    title: '百炼成神',
    author: '恩赐解脱',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20style%2C%20cultivation%20fantasy%20theme%2C%20young%20cultivator%20with%20flowing%20robes%20and%20sword%2C%20ancient%20Chinese%20mountain%20landscape%2C%20golden%20and%20crimson%20tones%2C%20clean%20illustration%20style%2C%20manga%20cover%20layout%2C%20epic%20composition%20with%20divine%20light&width=400&height=560&seq=manga-bailian&orientation=portrait',
    category: '玄幻',
    rating: 9.0,
    status: '连载中',
    description: '罗征，一个从蛮荒走出的少年，被家族遗弃，被视为废柴。但他没有放弃，凭借着一颗永不屈服的心，在逆境中一步步成长。百炼成神，唯我独尊！这是一段逆天改命的热血传奇。',
    views: 7200000,
    favorites: 520000,
    updatedAt: '2026-08-05',
    chapters: [
      { id: 1, title: '第1话 废柴少年', number: 1 },
      { id: 2, title: '第2话 神秘传承', number: 2 },
      { id: 3, title: '第3话 突破', number: 3 },
      { id: 4, title: '第4话 宗门试炼', number: 4 },
      { id: 5, title: '第5话 一战成名', number: 5 },
    ],
    tags: ['玄幻', '热血', '修仙', '逆袭'],
  },
  {
    id: 8,
    title: '偷星九月天',
    author: '周洪滨',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20style%2C%20fantasy%20romance%20theme%2C%20handsome%20thief%20and%20beautiful%20girl%20under%20starry%20night%2C%20deep%20blue%20and%20silver%20tones%2C%20mysterious%20and%20romantic%20atmosphere%2C%20clean%20illustration%20style%2C%20manga%20cover%20layout%2C%20elegant%20composition&width=400&height=560&seq=manga-touxing&orientation=portrait',
    category: '恋爱',
    rating: 9.4,
    status: '已完结',
    description: '大盗九月天盗走了古悉兰王朝的秘宝——紫微星，引发了琉星与九月之间一段跨越千年的爱恨纠葛。当命运的齿轮开始转动，谁才是真正的偷星之人？',
    views: 11000000,
    favorites: 820000,
    updatedAt: '2026-06-15',
    chapters: [
      { id: 1, title: '第1话 大盗九月天', number: 1 },
      { id: 2, title: '第2话 琉星登场', number: 2 },
      { id: 3, title: '第3话 紫微星之谜', number: 3 },
      { id: 4, title: '第4话 古悉兰', number: 4 },
      { id: 5, title: '第5话 命运的相遇', number: 5 },
    ],
    tags: ['恋爱', '奇幻', '冒险', '转世'],
  },
];

export const reviews: Review[] = [
  {
    id: 1,
    username: '漫画迷小王',
    avatar: '',
    rating: 5,
    content: '虫虫漫画真的是我用过最好用的漫画平台！更新速度超快，画质清晰，而且完全免费。每天必刷！',
    date: '2026-08-01',
  },
  {
    id: 2,
    username: '二次元少女',
    avatar: '',
    rating: 5,
    content: '资源太全了，想看的漫画基本都能找到。界面也很清爽，没有乱七八糟的广告，阅读体验很好！',
    date: '2026-07-28',
  },
  {
    id: 3,
    username: '热血漫迷',
    avatar: '',
    rating: 4,
    content: '追了斗罗大陆好久了，这边更新跟官网同步，而且加载很流畅。收藏功能也很好用，可以随时关注更新。',
    date: '2026-07-25',
  },
  {
    id: 4,
    username: '深夜读者',
    avatar: '',
    rating: 5,
    content: '晚上睡不着的时候就打开虫虫漫画看几话，已经成为习惯了。分类很清晰，找漫画很方便。推荐！',
    date: '2026-07-20',
  },
  {
    id: 5,
    username: '国漫支持者',
    avatar: '',
    rating: 5,
    content: '作为一名国漫爱好者，虫虫漫画的国漫资源让我非常满意。希望平台越做越好，支持国产漫画！',
    date: '2026-07-18',
  },
  {
    id: 6,
    username: '漫画老炮',
    avatar: '',
    rating: 4,
    content: '从纸质漫画时代一路看过来的，虫虫漫画的阅读体验不输纸质，缩放和翻页都很顺滑。老漫迷表示很认可。',
    date: '2026-07-15',
  },
];